import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://fk-alatau.kz';

const resolveUrl = (value) => new URL(value, SITE_URL).toString();

const SeoMeta = ({ title, description, image }) => {
  const location = useLocation();
  const pageUrl = resolveUrl(`${location.pathname}${location.search}`);
  const imageUrl = image.startsWith('http') ? image : resolveUrl(image);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="LSTK Production" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default SeoMeta;
